<div class="la-error-modal">
  <div class="modal-body">
    @for (errMsg of data.errorMessages; track errMsg) {
      <p [innerHTML]="errMsg.description || errMsg.message || errMsg"></p>
    }
  </div>
  <div class="modal-footer">
    @if (hasCancel) {
      <button
        class="button laAction laSecondary" (click)="cancel()">
        Cancel
      </button>
    }
    <button
      type="button" class="button laAction" (click)="confirm()">
      Okay
    </button>
  </div>
</div>
